<template>
  <div class="page" :style="bgStyle">

    <!-- ÉXITO -->
    <div v-if="enviado" class="success-page" :style="successPageStyle">
      <div class="success-content">
        <div class="success-check">✓</div>
        <h2 class="success-title">¡Gracias por tu participación!</h2>
        <p class="success-msg">Tu opinión es parte del éxito de la<br/><strong>Convención Comercial 2026.</strong></p>
        <p class="success-hash">#OrgulloMexa #RifadosConvención2026</p>
        <button class="btn-regresar" @click="$router.push('/')">Regresar al inicio</button>
      </div>
    </div>

    <!-- FORMULARIO -->
    <div v-else class="form-wrapper">

      <!-- LOGO BANNER -->
      <div class="logo-band" :style="logoBandStyle"></div>

      <!-- Texto intro -->
      <p class="intro-sobre">
        Gracias, mi gente, por ser parte de la Convención Rifados 2026 #OrgulloMexa.<br/>
        Tu opinión es la mera clave pa' que sigamos afinando el ambiente y las experiencias de nuestros eventazos.
      </p>

      <div class="form-card">

        <!-- TÍTULO -->
        <div class="titulo-wrap">
          <img src="/encuesta/titulo2.png" class="titulo-img" alt="Encuesta de Satisfacción" />
        </div>

        <form @submit.prevent="enviar">

          <!-- Nombre y Canal -->
          <div class="row-nombre">
            <div class="campo-txt">
              <label>Nombre</label>
              <input v-model="form.nombre" type="text" placeholder="Nombre" required />
            </div>
            <div class="campo-txt">
              <label>Canal</label>
              <input v-model="form.canal" type="text" placeholder="Canal" required />
            </div>
          </div>

          <!-- ESCALA -->
          <div class="escala-wrap">
            <p class="escala-intro">Responde la encuesta con esta escala:</p>
            <img :src="isMobile ? '/encuesta/emojim.png' : '/encuesta/emoji.png'" class="escala-img" alt="Escala" />
          </div>

          <!-- 1. EVALUACIÓN GENERAL -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">1. Evaluación General del Evento</h3>
            <div class="grid-2">
              <Pregunta v-model="form.eval_satisfaccion_general"  label="Satisfacción general con el evento de principio a fin" />
              <Pregunta v-model="form.eval_organizacion_logistica" label="Organización y logística general" />
            </div>
          </div>

          <!-- 2. LOGÍSTICA Y VIAJE -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">2. Logística y Experiencia de Viaje</h3>
            <div class="grid-2">
              <Pregunta v-model="form.log_vuelos"       label="Coordinación de vuelos y aerolíneas" />
              <Pregunta v-model="form.log_indicaciones" label="Instrucciones claras y precisas de vuelos, traslados y hospedaje" />
              <Pregunta v-model="form.log_traslado"     label="Traslados (aeropuerto - hotel - actividades)" />
            </div>
          </div>

          <!-- 3. HOSPEDAJE -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">3. Hospedaje</h3>
            <div class="grid-2">
              <Pregunta v-model="form.hosp_registro_checkin" label="Proceso de registro y check-in en Paradisus Playa del Carmen" />
              <Pregunta v-model="form.hosp_calidad"          label="Calidad del hospedaje en Paradisus Playa del Carmen" />
              <Pregunta v-model="form.hosp_servicio"         label="Servicio del hotel" />
              <Pregunta v-model="form.hosp_alimentos"        label="Calidad de alimentos en general" />
            </div>
          </div>

          <!-- 4. ACTIVIDADES -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">4. Actividades y Experiencias</h3>
            <p class="sec-sub">Califica cada actividad:</p>
            <div class="grid-2">
              <Pregunta v-model="form.act_coctel_bienvenida"   label="Cóctel de bienvenida (Honor)" />
              <Pregunta v-model="form.act_stand_xiaomi"        label="Stand Xiaomi" />
              <Pregunta v-model="form.act_stand_oppo"          label="Stand Oppo" />
              <Pregunta v-model="form.act_stand_honor"         label="Stand Honor" />
              <Pregunta v-model="form.act_cena_sonidera"       label="Cena Sonidera (martes)" />
              <Pregunta v-model="form.act_conferencia_piojo"   label='Conferencia de Miguel "El Piojo" Herrera' />
              <Pregunta v-model="form.act_integracion_rally"   label="Actividad de integración (Rally Playa)" />
              <Pregunta v-model="form.act_cena_clausura"       label="Cena de clausura (show Mariachis)" />
              <Pregunta v-model="form.act_after_party"         label="After Party" />
            </div>
          </div>

          <!-- 5. CONTENIDOS -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">5. Contenido y Sesiones</h3>
            <div class="grid-2">
              <Pregunta v-model="form.cont_claridad"   label="Claridad de la información presentada" />
              <Pregunta v-model="form.cont_relevancia" label="Relevancia del contenido para tu trabajo" />
              <Pregunta v-model="form.cont_duracion"   label="Duración de las sesiones" />
            </div>
          </div>

          <!-- 7. PARTICIPACIONES -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">7. Participaciones Especiales</h3>
            <div class="grid-2">
              <Pregunta v-model="form.part_honor"  label="Participación de Honor en sesión plenaria" />
              <Pregunta v-model="form.part_xiaomi" label="Participación de Xiaomi en sesión plenaria y cena" />
              <Pregunta v-model="form.part_oppo"   label="Participación de Oppo en sesión plenaria y cena" />
            </div>
          </div>

          <!-- 8. ABIERTAS -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">8. Información relevante de las sesiones plenarias:</h3>
            <div class="campo-abierto">
              <label>¿Qué mensajes clave te llevas de las sesiones plenarias?</label>
              <textarea v-model="form.mensajes_clave" rows="3" placeholder="Tu respuesta..."></textarea>
            </div>
            <div class="campo-abierto">
              <label>¿Qué fortalezas identificas en el equipo para alcanzar nuestras metas?</label>
              <textarea v-model="form.fortalezas_equipo" rows="3" placeholder="Tu respuesta..."></textarea>
            </div>
          </div>

          <!-- 9. RETROALIMENTACIÓN -->
          <div class="seccion">
            <hr class="linea" />
            <h3 class="sec-titulo">9. Retroalimentación Final</h3>
            <div class="campo-abierto">
              <label>¿Qué fue lo que más te gustó del evento?</label>
              <textarea v-model="form.gusto_evento" rows="3" placeholder="Tu respuesta..."></textarea>
            </div>
            <div class="campo-abierto">
              <label>¿Tienes alguna sugerencia o comentario adicional?</label>
              <textarea v-model="form.sugerencia" rows="3" placeholder="Tu respuesta..."></textarea>
            </div>
          </div>

          <p v-if="error" class="error-msg">{{ error }}</p>

          <div class="footer-btns">
            <button type="button" class="btn-volver" @click="$router.push('/')">← Regresar</button>
            <button type="submit" class="btn-enviar" :disabled="loading">
              ✦ {{ loading ? 'Enviando...' : 'Enviar respuestas' }}
            </button>
          </div>

        </form>

        <p class="footer-txt">
          Muchas gracias por tu opinión y participación.<br/>
          ¡Nos vemos en la próxima!
        </p>
      </div>
    </div>
  </div>
</template>

<script>
const Pregunta = {
  name: 'Pregunta',
  props: { value: { type: Number, default: null }, label: String },
  data() {
    return { titulos: ['Nada satisfecho','Poco satisfecho','Satisfecho','Bastante satisfecho','Muy satisfecho'] }
  },
  template: `
    <div class="pregunta">
      <p class="p-label">{{ label }}</p>
      <div class="p-caras">
        <button v-for="n in 5" :key="n" type="button" class="cara-btn"
          :class="{ sel: value !== null && n <= value }"
          @click="$emit('input', n)"
          :title="titulos[n-1]">
          <img :src="(value !== null && n <= value) ? '/encuesta/'+n+'b.png' : '/encuesta/'+n+'f.png'"
               class="cara-img" :alt="titulos[n-1]" />
        </button>
      </div>
    </div>
  `
}

export default {
  name: 'EncuestaView',
  components: { Pregunta },
  data() {
    return {
      enviado: false, loading: false, error: '',
      isMobile: window.innerWidth <= 768,
      form: {
        nombre: '', canal: '',
        eval_satisfaccion_general: null, eval_organizacion_logistica: null,
        log_vuelos: null, log_indicaciones: null, log_traslado: null,
        hosp_registro_checkin: null, hosp_calidad: null, hosp_servicio: null, hosp_alimentos: null,
        act_coctel_bienvenida: null, act_stand_xiaomi: null, act_stand_oppo: null, act_stand_honor: null,
        act_cena_sonidera: null, act_conferencia_piojo: null, act_integracion_rally: null,
        act_cena_clausura: null, act_after_party: null,
        cont_claridad: null, cont_relevancia: null, cont_duracion: null,
        part_honor: null, part_xiaomi: null, part_oppo: null,
        mensajes_clave: '', fortalezas_equipo: '',
        gusto_evento: '', sugerencia: ''
      }
    }
  },
  computed: {
    bgStyle() { return {} },
    successPageStyle() {
      const img = this.isMobile ? '/mexa/fondo-movil.jpg' : '/mexa/fondo-encuesta.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#009fe3'
      }
    },
    logoBandStyle() {
      const img = this.isMobile ? '/mexa/fondo-movil.jpg' : '/mexa/fondo-encuesta.jpg'
      return {
        backgroundImage: `url(${img})`,
        backgroundSize: 'cover',
        backgroundPosition: 'top center',
        backgroundRepeat: 'no-repeat'
      }
    }
  },
  mounted()       { window.addEventListener('resize', this.onResize) },
  beforeDestroy() { window.removeEventListener('resize', this.onResize) },
  methods: {
    onResize() { this.isMobile = window.innerWidth <= 768 },
    async enviar() {
      this.error = ''
      this.loading = true
      try {
        await this.$api.post('encuesta-convencion26/store', this.form)
        this.enviado = true
        window.scrollTo({ top: 0, behavior: 'smooth' })
      } catch {
        this.error = 'Ocurrió un error al enviar. Intenta de nuevo.'
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style>
.page {
  min-height: 100vh;
  background: #009fe3;
  display: flex; justify-content: center; align-items: flex-start;
  padding: 0 16px 48px;
}

/* ÉXITO - pantalla completa */
.success-page {
  position: fixed; inset: 0;
  display: flex; flex-direction: column;
  align-items: center; justify-content: flex-start;
  z-index: 100; overflow-y: auto;
}
.success-content {
  display: flex; flex-direction: column;
  align-items: center; text-align: center;
  padding: clamp(360px, 62vh, 580px) 24px 48px;
  gap: 16px;
  transform: translateX(18%);
}
.success-check {
  width: 64px; height: 64px;
  background: #fff; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  font-size: 32px; color: #009fe3; font-weight: bold;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}
.success-title {
  color: #fff; font-size: clamp(20px, 4vw, 28px);
  font-family: TelefonicaRegular, sans-serif; margin: 0;
}
.success-msg {
  color: rgba(255,255,255,0.92); font-size: 15px;
  line-height: 1.7; margin: 0;
}
.success-msg strong { color: #fff; }
.success-hash { color: rgba(255,255,255,0.75); font-size: 13px; margin: 0; }
.btn-regresar {
  padding: 12px 36px; background: #fff;
  color: #009fe3; border: none; border-radius: 30px;
  font-size: 15px; cursor: pointer; font-family: TelefonicaRegular, sans-serif;
  font-weight: bold; transition: background 0.2s, color 0.2s;
  margin-top: 6px;
}
.btn-regresar:hover { background: #003087; color: #fff; }

/* CARD */
.form-wrapper { width: 100%; max-width: 860px; }

/* LOGO BANNER: controla la altura para cambiar tamaño del logo */
.logo-band {
  width: 100vw;
  margin-left: calc(-50vw + 50%);
  height: clamp(260px, 55vh, 580px);
  position: relative;
}
.logo-band::after {
  content: '';
  position: absolute;
  bottom: 0; left: 0; right: 0;
  height: 50px;
  background: linear-gradient(to bottom, transparent, #009fe3);
}

.intro-sobre {
  text-align: center;
  color: rgba(255,255,255,0.92);
  font-size: 13px;
  line-height: 1.7;
  margin: 0;
  padding: 10px 20px 14px;
}

.form-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 8px 40px rgba(0,0,0,0.3);
  overflow: hidden;
  padding-bottom: 36px;
}

/* TÍTULO */
.titulo-wrap { text-align: center; padding: 22px 36px 0; }
.titulo-img  { height: clamp(50px, 6vw, 80px); width: auto; }

/* FORM */
form { padding: 0 36px; }

.row-nombre {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 20px; margin: 18px 0 0;
}
.campo-txt { display: flex; flex-direction: column; gap: 3px; }
.campo-txt label { font-size: 11px; color: #aaa; text-transform: uppercase; letter-spacing: 0.5px; }
.campo-txt input {
  padding: 7px 0; border: none; border-bottom: 1px solid #ccc;
  font-size: 14px; outline: none; background: transparent;
  font-family: TelefonicaRegular, sans-serif;
}
.campo-txt input:focus { border-bottom-color: #009fe3; }

/* ESCALA */
.escala-wrap { padding: 14px 0 0; }
.escala-intro { font-size: 13px; color: #444; font-weight: bold; margin-bottom: 6px; }
.escala-img  { max-width: 100%; height: auto; }

/* SECCIÓN */
.seccion { margin-bottom: 4px; }
.linea {
  border: none;
  border-top: 1px solid #e0e0e0;
  margin: 16px 0 10px;
}
.sec-titulo {
  font-size: 13px; font-weight: bold; color: #333;
  margin-bottom: 8px; font-family: TelefonicaRegular, sans-serif;
}
.sec-sub { font-size: 12px; color: #888; margin-bottom: 8px; }

/* GRID 2 COLUMNAS */
.grid-2 {
  display: grid; grid-template-columns: 1fr 1fr;
  gap: 6px 28px;
}

/* PREGUNTA */
.pregunta {
  display: flex; flex-direction: column; gap: 6px;
  padding: 8px 0; border-bottom: 1px solid #f0f0f0;
}
.p-label { font-size: 12px; color: #444; line-height: 1.35; margin: 0; }
.p-caras { display: flex; gap: 3px; align-items: center; }
.cara-btn {
  background: none; border: none; padding: 2px; cursor: pointer;
  border-radius: 50%; outline: none; transition: transform 0.15s;
}
.cara-btn:hover  { transform: scale(1.2); }
.cara-btn.sel    { transform: scale(1.12); }
.cara-img        { width: 33px; height: 33px; object-fit: contain; display: block; }

/* ABIERTAS */
.campo-abierto  { display: flex; flex-direction: column; gap: 4px; margin-bottom: 14px; }
.campo-abierto label { font-size: 12px; color: #555; }
.campo-abierto textarea {
  padding: 8px 12px; border: 1px solid #ddd; border-radius: 6px;
  font-size: 13px; resize: vertical; outline: none; font-family: TelefonicaRegular, sans-serif;
}
.campo-abierto textarea:focus { border-color: #009fe3; }

/* BOTÓN */
.footer-btns { display: flex; justify-content: center; gap: 16px; margin-top: 28px; }
.btn-enviar {
  padding: 12px 44px; background: #009fe3; color: #fff;
  border: none; border-radius: 30px; font-size: 15px; cursor: pointer;
  font-family: TelefonicaRegular, sans-serif; transition: background 0.2s;
}
.btn-enviar:hover    { background: #007ab8; }
.btn-enviar:disabled { opacity: 0.6; cursor: not-allowed; }
.btn-volver {
  padding: 12px 28px; background: transparent;
  color: #009fe3; border: 2px solid #009fe3; border-radius: 30px;
  font-size: 15px; cursor: pointer; font-family: TelefonicaRegular, sans-serif;
  transition: background 0.2s, color 0.2s;
}
.btn-volver:hover { background: #009fe3; color: #fff; }

.footer-txt  { text-align: center; color: #aaa; font-size: 12px; margin-top: 24px; line-height: 1.7; }
.error-msg   { text-align: center; color: #e53935; font-size: 13px; margin-top: 8px; }

/* MOBILE */
@media (max-width: 768px) {
  .page           { padding: 0 0 40px; background: #009fe3; }
  .form-wrapper   { max-width: 100%; }
  .logo-band      { margin-left: 0; width: 100%; height: clamp(220px, 48vw, 320px); }
  .logo-band::after { height: 30px; }
  .intro-sobre    { font-size: 12px; padding: 8px 16px 12px; }
  .form-card      { border-radius: 12px 12px 0 0; }
  .titulo-wrap    { padding: 14px 16px 0; }
  .titulo-img     { height: clamp(36px, 8vw, 52px); }
  form            { padding: 0 14px; }
  .row-nombre     { grid-template-columns: 1fr; gap: 10px; }
  .grid-2         { grid-template-columns: 1fr; }
  .cara-img       { width: 34px; height: 34px; }
  .p-label        { font-size: 11px; }
  .footer-btns    { flex-direction: column; align-items: center; gap: 10px; }
  .btn-enviar, .btn-volver { width: 100%; max-width: 260px; font-size: 14px; }
  .escala-img     { max-width: 90%; }
  .success-content {
    transform: translateX(0);
    padding: clamp(220px, 48vh, 360px) 24px 40px;
  }
  .success-check  { width: 52px; height: 52px; font-size: 26px; }
  .success-title  { font-size: 20px; }
  .success-msg    { font-size: 14px; }
}

/* PANTALLAS GRANDES */
@media (min-width: 1600px) {
  .form-wrapper { max-width: 960px; }
}
</style>
